<template>
  <div>
    <b-row>
    <div class="col-6">
      <b-form-group label="Screen" label-cols="4">
        <b-form-select class="col-8" v-model="screen_id" :options="screens"></b-form-select>
      </b-form-group>
      <b-form-group label="Element" label-cols="4">
        <b-form-select class="col-8" v-model="screenelement_id" :options="screenelements"></b-form-select>
      </b-form-group>
      <b-form-group label="Text" label-cols="4">
        <b-form-textarea 
          class="col-8" 
          v-model="screenelement_text"
          v-on:blur="savefield('g_systemscreenelements',screenelement_id,'element_text',screenelement_text)"
        ></b-form-textarea>
      </b-form-group>
      <b-form-group label="Help bubble" label-cols="4">
        <b-form-textarea 
          class="col-8" 
          v-model="screenelement_bubble"
          v-on:blur="savefield('g_systemscreenelements',screenelement_id,'element_bubbletext',screenelement_bubble)"
        ></b-form-textarea>
      </b-form-group>
    </div>
    <div class="col-6 align-top">
      <img :src="require('../assets/systemscreens/Screen_'+screen_id+'.png')" class="col-12">
    </div>
    </b-row>
  </div>
</template>
<script>
export default {
  components: {
  },
  name: 'SystemTexts',
  mounted() {
    this.screens_get();
  },
  data: function() {
    return {
      screen_id: 0,
      screens: [],
      screenelement_id: null,
      screenelements: [],
      screenelement_text: '',
      screenelement_bubble: '',
      imgname: 'Screen_1.png',
    }
  },
  computed: {
  },
  watch: {
    screen_id: function() {
      this.screenelements_get();
    },
    screenelement_id: function() {
      this.screenelement_get();
    },
  },
  methods: {
    savefield(tablename,id,fieldname,value) {
      if ( id > 0 && id != null) {
        var record = {
          id: id,
          [fieldname]: value,
        }
        this.$store.dispatch('field_save', { tablename: tablename,record: record })
        .then(() => {
          this.$store.dispatch('consultantchanged_set',{ consultant_id: this.consultant_id });
        });
      }
    },
    screens_get() {
      this.screens = [];
      this.screens.push( { value: null, text: 'Please select screen' });
      this.$store.dispatch("systemscreens_fetch")
      .then((resp) => {
        var screens = resp.data.result;
        for (var i=0;i<screens.length;i++) {
          var screen = {
            value: screens[i].id,
            text: screens[i].screen_name,
          }
          this.screens.push(screen);
        }
      })
    },
    screenelements_get() {
      this.screenelements = [];
      this.screenelements.push( { value: null, text: 'Please select element' });
      if (this.screen_id != null) {
        var filter = {
          screen_id: {
            operator: '=',
            value: this.screen_id,
          }
        }
        this.$store.dispatch("systemscreenelements_fetch", { filter: filter })
        .then((resp) => {
          var screenelements = resp.data.result;
          for (var i=0;i<screenelements.length;i++) {
            var screenelement = {
              value: screenelements[i].id,
              text: screenelements[i].element_name,
            }
            this.screenelements.push(screenelement);
          }
        })
      }
    },
    screenelement_get() {
      this.screenelement_text = '';
      this.screenelement_bubble = '';
      if (this.screenelement_id != null) {
        this.$store.dispatch("systemscreenelement_fetch", { id: this.screenelement_id })
        .then((resp) => {
          this.screenelement_text = resp.data.element_text;
          this.screenelement_bubble = resp.data.element_bubbletext;
        });
      }
    },
    screenelement_save() {
      var data = {
        id: this.screenelement_id,
        screen_id: this.screen_id,
        element_text: this.screenelement_text,
        element_bubbletext: this.screenelement_bubble,
      }
      this.$store.dispatch("systemscreenelement_save", { record: data })
      .then((resp) => {
        return resp;
      });
    },
  }
}
</script>
<style>
</style>
